import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import LandingHeader from "../../components/landing/LandingHeader";
import LandingFooter from "../../components/landing/LandingFooter";
import { useTranslation } from "../../contexts/TranslationContext";
import "../../assets/css/landing.css";
import "./Home.css";
import "./LegalPage.css";

const TermsAndConditions = () => {
  const { t, isRTL } = useTranslation();
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    document.body.classList.add("hl-body");
    return () => document.body.classList.remove("hl-body");
  }, []);

  return (
    <div className="hl-page hl-legal-page">
      <div className="hl-top-band">
        <LandingHeader />

        <div className="heading-policy flex-column">
          <h1>{t("termsAndConditions.title")}</h1>
        </div>
      </div>

      <div className="container terms-container" dir={isRTL ? 'rtl' : 'ltr'} style={{ fontFamily: 'Inter, sans-serif', fontSize: '16px' }}>
        <div className="text-center terms-meta">
          <p className="terms-meta-text">{t("termsAndConditions.lastUpdated")}</p>
        </div>
        <div className="privacy-heading terms-content" style={{ fontFamily: 'Inter, sans-serif', fontSize: '16px' }}>
          <p className="terms-section-content" dangerouslySetInnerHTML={{ __html: t("termsAndConditions.intro") }}></p>

          <h3 className={`terms-section-title ${isRTL ? "mt-5" : "mt-4"}`}>{t("termsAndConditions.platformRole.title")}</h3>
          <p className="terms-section-content" dangerouslySetInnerHTML={{ __html: t("termsAndConditions.platformRole.content") }}></p>

          <h3 className={`terms-section-title ${isRTL ? "mt-5" : "mt-4"}`}>{t("termsAndConditions.userAccounts.title")}</h3>
          <p className="terms-section-content" dangerouslySetInnerHTML={{ __html: t("termsAndConditions.userAccounts.content") }}></p>

          <h3 className={`terms-section-title ${isRTL ? "mt-5" : "mt-4"}`}>{t("termsAndConditions.vendorAccounts.title")}</h3>
          <p className="terms-section-content" dangerouslySetInnerHTML={{ __html: t("termsAndConditions.vendorAccounts.content") }}></p>

          <h3 className={`terms-section-title ${isRTL ? "mt-5" : "mt-4"}`}>{t("termsAndConditions.bookings.title")}</h3>
          <p className="terms-section-content" dangerouslySetInnerHTML={{ __html: t("termsAndConditions.bookings.content") }}></p>

          <h3 className={`terms-section-title ${isRTL ? "mt-5" : "mt-4"}`}>{t("termsAndConditions.payments.title")}</h3>
          <p className="terms-section-content" dangerouslySetInnerHTML={{ __html: t("termsAndConditions.payments.content") }}></p>

          <h3 className={`terms-section-title ${isRTL ? "mt-5" : "mt-4"}`}>{t("termsAndConditions.cancellationRefund.title")}</h3>
          <p className="terms-section-content" dangerouslySetInnerHTML={{ __html: t("termsAndConditions.cancellationRefund.content") }}></p>

          <h3 className={`terms-section-title ${isRTL ? "mt-5" : "mt-4"}`}>{t("termsAndConditions.commissionPolicy.title")}</h3>
          <p className="terms-section-content" dangerouslySetInnerHTML={{ __html: t("termsAndConditions.commissionPolicy.content") }}></p>

          <h3 className={`terms-section-title ${isRTL ? "mt-5" : "mt-4"}`}>{t("termsAndConditions.platformCommission.title")}</h3>
          <p className="terms-section-content" dangerouslySetInnerHTML={{ __html: t("termsAndConditions.platformCommission.content") }}></p>

          <h3 className={`terms-section-title ${isRTL ? "mt-5" : "mt-4"}`}>{t("termsAndConditions.reviewsContent.title")}</h3>
          <p className="terms-section-content" dangerouslySetInnerHTML={{ __html: t("termsAndConditions.reviewsContent.content") }}></p>

          <h3 className={`terms-section-title ${isRTL ? "mt-5" : "mt-4"}`}>{t("termsAndConditions.prohibitedActivities.title")}</h3>
          <p className="terms-section-content" dangerouslySetInnerHTML={{ __html: t("termsAndConditions.prohibitedActivities.content") }}></p>

          <h3 className={`terms-section-title ${isRTL ? "mt-5" : "mt-4"}`}>{t("termsAndConditions.limitationOfLiability.title")}</h3>
          <p className="terms-section-content" dangerouslySetInnerHTML={{ __html: t("termsAndConditions.limitationOfLiability.content") }}></p>

          <h3 className={`terms-section-title ${isRTL ? "mt-5" : "mt-4"}`}>{t("termsAndConditions.privacyPolicy.title")}</h3>
          <p className="terms-section-content" dangerouslySetInnerHTML={{ __html: t("termsAndConditions.privacyPolicy.content") }}></p>

          <h3 className={`terms-section-title ${isRTL ? "mt-5" : "mt-4"}`}>{t("termsAndConditions.intellectualProperty.title")}</h3>
          <p className="terms-section-content" dangerouslySetInnerHTML={{ __html: t("termsAndConditions.intellectualProperty.content") }}></p>

          <h3 className={`terms-section-title ${isRTL ? "mt-5" : "mt-4"}`}>{t("termsAndConditions.changesToTerms.title")}</h3>
          <p className="terms-section-content" dangerouslySetInnerHTML={{ __html: t("termsAndConditions.changesToTerms.content") }}></p>

          <h3 className={`terms-section-title ${isRTL ? "mt-5" : "mt-4"}`}>{t("termsAndConditions.governingLaw.title")}</h3>
          <p className="terms-section-content" dangerouslySetInnerHTML={{ __html: t("termsAndConditions.governingLaw.content") }}></p>

          <h3 className={`terms-section-title ${isRTL ? "mt-5" : "mt-4"}`}>{t("termsAndConditions.contactInfo.title")}</h3>
          <p className="terms-section-content">{t("termsAndConditions.contactInfo.intro")}</p>
          <div className="terms-contact-info">
            <p className="terms-section-content">{t("termsAndConditions.contactInfo.company")}</p>
            <p className="terms-section-content">{t("termsAndConditions.contactInfo.website")}</p>
            <p className="terms-section-content">{t("termsAndConditions.contactInfo.email")}</p>
            {/* <p className="terms-section-content">{t("termsAndConditions.contactInfo.phone")}</p> */}
          </div>

          <p className="terms-section-content terms-legal-info mt-4"><em>{t("termsAndConditions.acknowledgment.content")}</em></p>
        </div>
      </div>

      <LandingFooter />
    </div>
  );
};

export default TermsAndConditions;
